import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { useSite } from '../context/SiteContext';
import { useT } from '../context/I18nContext';

const HERO_LOGO_FALLBACK = 'https://customer-assets.emergentagent.com/job_vape-shop-crypto/artifacts/swu5ykxs_Scherm%C2%ADafbeelding%202026-06-25%20om%2000.35.16.png';

const Hero = () => {
  const { site } = useSite();
  const { t } = useT();
  const logo = site?.brand?.hero_logo_url || HERO_LOGO_FALLBACK;
  return (
    <section className="relative bg-black overflow-hidden">
      {/* gold radial light */}
      <div className="absolute inset-0 pointer-events-none" style={{
        background: 'radial-gradient(ellipse 70% 60% at 70% 50%, rgba(212,175,55,0.28) 0%, rgba(0,0,0,0) 60%)'
      }} />
      {/* particles via subtle dots */}
      <div className="absolute inset-0 opacity-30 pointer-events-none" style={{
        backgroundImage: 'radial-gradient(circle at 65% 40%, rgba(255,215,130,0.08) 0%, transparent 50%), radial-gradient(circle at 80% 60%, rgba(212,175,55,0.12) 0%, transparent 60%)'
      }} />

      <div className="relative max-w-[1480px] mx-auto px-6 py-20 lg:py-28 grid lg:grid-cols-2 gap-10 items-center min-h-[640px]">
        <div className="relative z-10">
          <p className="text-[#d4af37] tracking-[0.4em] text-xs uppercase mb-5">{t('hero.eyebrow')}</p>
          <h1 className="serif-italic gold-gradient-text text-6xl md:text-7xl lg:text-8xl leading-[0.95]">
            {t('hero.tagline1')}<br/>{t('hero.tagline2')}
          </h1>
          <p className="mt-6 text-zinc-300 max-w-lg leading-relaxed">
            {t('hero.subtitle')}
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            <Link to="/shop"><Button className="btn-gold px-8 h-12 text-[15px] tracking-wider uppercase">{t('hero.cta_primary')}</Button></Link>
            <Link to="/shop?cat=15k"><Button variant="outline" className="btn-outline-gold px-8 h-12 text-[15px] tracking-wider uppercase">{t('hero.cta_secondary')}</Button></Link>
          </div>
          <div className="mt-10 flex flex-wrap gap-x-10 gap-y-3 text-sm text-zinc-400">
            <span>✔ {t('hero.f_puffs')}</span>
            <span>✔ {t('hero.f_mesh')}</span>
            <span>✔ {t('hero.f_usb')}</span>
            <span>✔ {t('hero.f_authentic')}</span>
          </div>
        </div>

        {/* Brand logo (gorilla) */}
        <div className="relative h-[460px] lg:h-[560px] flex items-center justify-center gold-glow" data-testid="hero-brand-logo">
          <img
            src={logo}
            alt={site?.brand?.site_name || 'We Supply Smoke'}
            className="max-h-full max-w-full object-contain drop-shadow-[0_0_60px_rgba(212,175,55,0.35)]"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
